export { Provider as TooltipProvider } from "@radix-ui/react-tooltip";

export * from "@/ui/components/overlay/Tooltip/Tooltip";
export * from "@/ui/components/overlay/Tooltip/Tooltip.config";
export * from "@/ui/components/overlay/Tooltip/TooltipContent";
export * from "@/ui/components/overlay/Tooltip/TooltipShortcut";
export * from "@/ui/components/overlay/Tooltip/TooltipTrigger";
